export enum CompanyWithDescriptionCellBlock {
  Root = 'CompanyWithDescriptionCell',
}

export enum CompanyWithDescriptionCellElement {
  Description = 'description',
}
